import { Injectable } from '@angular/core';
import { Apollo, ApolloBase, gql } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { ApolloLink } from '@apollo/client/core';
import { BypassErrorLink } from '../abstract/bypass-error-link';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    private apollo: ApolloBase;
    constructor(private apolloProvider: Apollo) {
        this.apollo = this.apolloProvider.use('usersAPI');
    }

    public getUnreadNotifications(pageNumber: number, pageSize: number): Observable<any> {
        const getUserNotifications = `
                    query getUserNotifications  {
                        userNotifications {
                            getUserNotifications(
                                searchSettings: {
                                    pageNumber: ${pageNumber}
                                    pageSize: ${pageSize}
                                    orderDirection: DESC
                                    orderBy: "completedDateTime"
                                },
                                filtering: {
                                    isRead: false
                                    isCompleted: true
                                }
                            )  {
                                data {
                                    operationName
                                    notificationType
                                    startDateTime
                                    completedDateTime
                                    downloadLink
                                    userNotificationMetadataItems {
                                        key
                                        value
                                    }
                                },
                                totalCount
                            }
                        }
                    }
                `;

        return this.apollo
            .query({
                query: gql(getUserNotifications),
                fetchPolicy: 'no-cache',
            })
            .pipe(
                map((response: any) => {
                    return response.data.userNotifications.getUserNotifications;
                }),
            );
    }

    public getNewNotificationsCount(): Observable<any> {
        const getUserNotifications = `
            query {
                userNotifications {
                    getUserNotifications(
                        searchSettings: {
                            pageNumber: 1,
                            pageSize: 1
                        },
                        filtering: {
                            isRead: false
                            isCompleted: true
                        }
                    ) {
                        data {
                            id
                        }
                        totalCount
                    }
                }
            }
        `;

        return this.apollo
            .query({
                query: gql(getUserNotifications),
                fetchPolicy: 'no-cache',
            })
            .pipe(
                map((response: any) => {
                    return response.data.userNotifications.getUserNotifications.totalCount;
                }),
            );
    }

    public markNotificationsAsRead() {
        const markNotificationsAsReadMutation = `
                mutation markAllUserNotificationsAsRead {
                    userNotifications {
                        markAllUserNotificationsAsRead(
                            userNotification: null
                        ) {
                        statusCode
                        message
                    }
                }
            }
        `;

        return this.apollo.mutate({
            mutation: gql(markNotificationsAsReadMutation),
            context: {
                link: ApolloLink.from([new BypassErrorLink([400])]),
            },
        });
    }

    public getOperationStatus(operationName: string, pageNumber: number, pageSize: number): Observable<any> {
        const getUserNotifications = `
                    query getUserNotifications  {
                        userNotifications {
                            getUserNotifications(
                                searchSettings: {
                                    pageNumber: ${pageNumber}
                                    pageSize: ${pageSize}
                                    orderDirection: DESC
                                    orderBy: "startDateTime"
                                },
                                filtering: {
                                    operationName: "${operationName}"
                                }
                            )  {
                                data {
                                    status
                                },
                                totalCount
                            }
                        }
                    }
                `;

        return this.apollo
            .query({
                query: gql(getUserNotifications),
                fetchPolicy: 'no-cache',
            })
            .pipe(
                map((response: any) => {
                    return response.data.userNotifications.getUserNotifications;
                }),
            );
    }
}
